import {
    SourceType,
} from 'one-model-local';

import {
    SelectList,
} from 'one-state-core';

import {
    SET,
    REINIT,
    SELECT
} from './types';

import {
    Actions,
} from './actions';

/**
 *
 * @param context contains settings.json etc
 * @param initial initial state if set
 */
export const sourcetype = (
    context: any,
    initial?: SelectList<SourceType>,
) => {
    const initValue = initial || {
        values: undefined,
    };

    return (
        state: SelectList<SourceType>,
        action: Actions,
    ) => {
        const {
            type,
            payload,
        } = action;
        let updated = state || initValue;
        switch (type) {
            case SET:
                updated = {
                    ...updated,
                    values: payload
                }
                break;
            case SELECT:
                updated = {
                    ...updated,
                    selected: payload
                }
                break;
            case REINIT:
                updated = initValue;
                break;
        }
        return updated;
    }
};
